document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("enz-description");
  if (!container) return;

  const headings = container.querySelectorAll("h2");

  headings.forEach((heading) => {
    let content = document.createElement("div");
    content.classList.add("enz-accordion__content");

    let next = heading.nextElementSibling;

    // Collect content until next H2
    while (next && next.tagName !== "H2") {
      let temp = next.nextElementSibling;
      content.appendChild(next);
      next = temp;
    }

    // Accordion wrapper
    let wrapper = document.createElement("div");
    wrapper.classList.add("enz-accordion");

    // Header
    let header = document.createElement("div");
    header.classList.add("enz-accordion__header");

    header.innerHTML = `
      <span>${heading.innerHTML}</span>
      <span class="enz-accordion-icon"></span>
    `;

    // Toggle behavior
    header.addEventListener("click", () => {
      const allAccordions = container.querySelectorAll(".enz-accordion");

      allAccordions.forEach((acc) => {
        if (acc !== wrapper) {
          acc.classList.remove("toggled");
        }
      });

      wrapper.classList.toggle("toggled");
    });

    wrapper.appendChild(header);
    wrapper.appendChild(content);

    heading.replaceWith(wrapper);
  });

  // ✅ OPEN FIRST ACCORDION AFTER BUILD
  const firstAccordion = container.querySelector(".enz-accordion");
  if (firstAccordion) {
    firstAccordion.classList.add("toggled");
  }
});